import React from "react";
import { useSessionContext, useSpinnerContext } from '@contexts';
import { sunboundPayProxy } from '@proxies';
import { useNavigate } from 'react-router-dom';
import { FloatMenu } from "@common";
import { UserIcon } from "@heroicons/react/24/solid";

const Menu = () => {

    const { session, logout, accounts, changeSelectedResident, selectedAccount, showAccountSelector } = useSessionContext();
    const navigate = useNavigate();
    const { setSpinnerShow } = useSpinnerContext();

    const logoutClick = async () => {
        setSpinnerShow(true);
        logout();
        try {
            await sunboundPayProxy.logout();
        } catch (error) {
            console.log(error);
        }
        setSpinnerShow(false);
        navigate(`/login`);
    };

    const optionsMyAccount = [
        {
            title: `Dashboard`,
            action: `/`
        },
        {
            title: `Statements`,
            action: `/payment-history`
        },
        {
            title: `Settings`,
            action: `/myaccount`
        },
        {
            title: `Log out`,
            action: logoutClick
        }
    ];

    const changeResident = (idAccount) => {
        if (idAccount === selectedAccount.idAccount) return;
        changeSelectedResident(idAccount, navigate);
    };

    const residents = accounts.map(a => ({
        title: a.residentName,
        action: () => changeResident(a.idAccount)
    }));

    const currentAccount = session && session.hasPassword && (
        <div className="flex flex-row gap-x-1">
            <div><UserIcon width={20} className="inline-block" /></div><div className="underline font-bold">{selectedAccount.residentName}</div>
        </div>
    );

    return (
        <>
            {
                session && session.hasPassword &&
                <div className="flex flex-row gap-x-3">
                    {
                        showAccountSelector && accounts.length > 1 &&
                        <FloatMenu menu={currentAccount} chevron={false} options={residents} render={({ title, action }) =>
                            <li key={title} className="py-2 px-4 hover:bg-blue-200 cursor-pointer" onClick={action}>
                                <button
                                    className="background-transparent text-blue-text outline-none text-base focus:outline-none"
                                    type="button">
                                    <div className="flex flex-row gap-x-1">
                                        <div><UserIcon width={20} className="inline-block" /></div><div>{title}</div>
                                    </div>
                                </button >
                            </li>
                        } />
                    }

                    <FloatMenu
                        menu={<span className="font-bold">My Account</span>}
                        chevron={true}
                        options={optionsMyAccount} render={({ title, action }) =>
                            <li key={title} className="py-2 px-4 hover:bg-blue-200 cursor-pointer" onClick={action}>
                                <button
                                    className="background-transparent text-blue-text outline-none text-base focus:outline-none"
                                    type="button">
                                    {title}
                                </button >
                            </li>
                        } />
                </div>
            }
        </>
    );
};

export default Menu;